import React, { useEffect, useState } from 'react';
import { Badge } from '../ui/badge';
import { agenteAsistenciaAPI } from '../../services/api';
import { Cpu, Sparkles } from 'lucide-react';

// P13E — Indicador mínimo de estado de la asistencia IA (sin prometer funciones activas).
// Por defecto muestra "modo determinista" / "asistencia IA no configurada".
export const AsistenciaBadge = () => {
  const [estado, setEstado] = useState(null);
  useEffect(() => { agenteAsistenciaAPI.estado().then(setEstado).catch(() => {}); }, []);
  if (!estado) return null;
  const activa = estado.activa;
  return (
    <Badge className={activa ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-100 text-slate-600'}
           data-testid="asistencia-ia-badge">
      {activa
        ? <><Sparkles className="h-3 w-3 mr-1" />asistencia IA (revisar y confirmar)</>
        : <><Cpu className="h-3 w-3 mr-1" />modo determinista · IA no configurada</>}
    </Badge>
  );
};

export default AsistenciaBadge;
